document.addEventListener("DOMContentLoaded", function () {
  var totalPages = 0;

  function createPaginationLinks(totalPages) {
    var head = document.querySelector("head");

    function getCurrentPage() {
      var urlParams = new URLSearchParams(window.location.search);
      return parseInt(urlParams.get("page")) || 1;
    }

    function updatePaginationLinks() {
      var currentPage = getCurrentPage();

      var existingLinks = document.querySelectorAll('link[rel="prev"], link[rel="next"]');
      existingLinks.forEach(function (link) { link.remove(); });

      if (currentPage > 1) {
        var prevLink = document.createElement("link");
        prevLink.rel = "prev";
        prevLink.href = window.location.protocol + "//" + window.location.host + window.location.pathname + "?page=" + (currentPage - 1);
        head.appendChild(prevLink);
      }

      if (currentPage < totalPages) {
        var nextLink = document.createElement("link");
        nextLink.rel = "next";
        nextLink.href = window.location.protocol + "//" + window.location.host + window.location.pathname + "?page=" + (currentPage + 1);
        head.appendChild(nextLink);
      }
    }

    updatePaginationLinks();

    window.addEventListener("popstate", updatePaginationLinks);

    var originalPushState = history.pushState;
    history.pushState = function (state, title, url) {
      originalPushState.call(history, state, title, url);
      updatePaginationLinks();
    };

    var originalReplaceState = history.replaceState;
    history.replaceState = function (state, title, url) {
      originalReplaceState.call(history, state, title, url);
      updatePaginationLinks();
    };
  }

  function tryInitPagination() {
    var showingItemsElement = document.querySelector(".ns-viewed");
    if (!showingItemsElement) return false;

    var text = showingItemsElement.textContent.trim();
    var match = text.match(/of\s+(\d+)\s+products/i);
    if (!match) return true;

    var totalResults = parseInt(match[1]);
    if (!totalResults || isNaN(totalResults)) return true;

    var products = document.querySelectorAll("#ns-product-grid .ns-product");
    var pageSize = products.length;
    if (pageSize === 0) return false;

    if (totalPages === 0) {
      totalPages = Math.ceil(totalResults / pageSize);
    }

    if (totalPages > 0) {
      createPaginationLinks(totalPages);
      return true;
    }

    return false;
  }

  if (!tryInitPagination()) {
    var observerTarget = document.querySelector("#ns-product-grid") || document.body;
    var observer = new MutationObserver(function () {
      if (tryInitPagination()) observer.disconnect();
    });
    observer.observe(observerTarget, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 15000);
  }
});
